<template>
  <div class="col-12">
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show"  id="crypto-withdrawal" role="tabpanel" aria-labelledby="crypto-withdrawal-tab" >
        <div class="col-12 mob-pad-0" >
          <alert-notification v-if="notification_msg != '' && !showPopup" />
          <loader v-if="pageLoader && !showPopup" />
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between flex-wrap tHis my-5">
              <ul class="d-flex align-items-center priceTab mb-lg-0">
                <li class="nav-item">
                  <a class="nav-link" :class="taskTab == 'cryptoWithdrawal' ? 'active' : ''" id="crypto-withdrawal-tab" data-toggle="tab" href="#crypto-withdrawal" role="tab"
                    aria-controls="crypto-withdrawal" aria-selected="true" @click="taskTab = 'cryptoWithdrawal'">Crypto Withdrawal</a>
                </li>
                <li class="nav-item" v-if="(permissionModule('FIAT')) || (get_user.permissions == undefined && parseInt(get_user.profile.user_id) == 375)">
                  <a class="nav-link" :class="taskTab == 'fiatWithdrawal' ? 'active' : ''" id="fiat-withdrawal-tab" data-toggle="tab" href="#fiat-withdrawal" role="tab"
                    aria-controls="crypto-withdrawal" aria-selected="false" @click="taskTab = 'fiatWithdrawal'">Fiat Withdrawal</a>
                </li>
              </ul>
            </div>
          </div>
          
          <div class="row max-50" v-if="taskTab == 'cryptoWithdrawal'">
            <div class="col-12 col-lg-8">
              <div class="lightgrayBG selectWallet cap_exhange_cur w-100">
                <div class="walletBlock position-relative">
                  <label class="mb-2">Choose Wallet</label>
                  <div @click.stop="showCurr = !showCurr">
                    <div class="dropdown cap_fund cur_ico">
                      <button class="border bg-white cap_btn dropdown-toggle px-3" type="button">
                        <img class="cp__ico" :src="
                            '../../../../static/website/images/crypto_logos/' +
                            selected_currency.toLowerCase() +
                            '.png'
                          " alt="" @error="handleImgErr($event)" v-if="
                            selected_currency != '' && checkImage(selected_currency)
                          " />
                        <span class="firstName" v-else-if="selected_currency != ''">{{
                          selected_currency.charAt(0)
                          }}</span>
                        {{ selected_currency || "Select Currency" }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-menu rounded" :class="showCurr ? 'show' : ''">
                    <div class="cur_search showCurr">
                      <input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchCurr" id="searchCurr"
                        autocomplete="off" />
                    </div>
                    <div class="scrolling_text">
                      <table class="table table-striped">
                        <tbody v-if="withDepoCurList.length > 0">
                          <tr class="pointer" v-for="value in marginList()"  @click.prevent="currencyListNameFunc(value)" :class="currencyListNameClassFunc(value)"  >
                            <td>
                              <span class="d-flex align-items-center icNmae">
                                <img :src="
                                    '../../../../static/website/images/crypto_logos/' +
                                    value.symbol.toLowerCase() +
                                    '.png'
                                  " @error="handleImgErr($event)" v-if="checkImage(value.symbol)" />
                                <span class="firstName" v-else>{{value.symbol.charAt(0)}}</span>
                                <span class="muted semibold" v-if="$env_var.restricted_currencies.hasOwnProperty(value.symbol)">
                                  <span>{{ $env_var.restricted_currencies[value.symbol].currency_name}}</span>
                                  <span class="fullName">{{value.currency_name}}</span>
                                </span>
                                <span class="muted semibold" v-else>{{ value.symbol  }}<span class="fullName">{{  value.currency_name   }}</span></span>
                              </span>
                            </td>
                            <td align="right">
                              <span class="f-16 d-block">{{
                                formatfloat(value.amount) || 0
                                }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <p class="themecolor text-right mt-2 w-100">
                    Current Balance: {{ currentBal }} {{ selected_currency }}
                  </p>
                </div>
                <div class="walletBlock position-relative mb-4">
                  <label class="mb-2">Withdraw Amount</label>
                  <div class="position-relative p-0 form-group mb-0">
                    <input type="text" class="form-control copyCode" autocomplete="off" name="amount" required=""
                      placeholder="Enter Amount" v-model="withdraw_amount" v-validate="{
                        required: true,
                        decimal: 8,
                        max_value: currentBal,
                        regex: /^(?=.*[1-9])\d+(\.\d+)?$/,
                      }" />
                    <span class="copyBtn position-absolute topRT">{{
                      selected_currency
                      }}</span>
                  </div>
                  <span v-if="submitted && errors.has('amount')" class="text-danger">{{ errors.first("amount") }}</span>
                </div>
                <div class="walletBlock position-relative mb-4">
                  <label class="mb-2">Verify Crypto Address</label>
                  <div class="position-relative p-0">
                    <input type="text" class="form-control copyCode" autocomplete="off" name="addess" required=""
                      placeholder="Enter Crypto Address" v-model="crypto_addess" v-validate="'required'" />
                    
                  </div>
                  <span v-if="submitted && errors.has('amount')" class="text-danger">{{
                    errors.first("amount").includes("format is invalid")
                    ? "Amount should be greater than 0"
                    : errors.first("amount")
                    }}</span>
                  
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="transactionDetails">
                <label class="medium mb-2">Transaction Details:</label>
                <div class="transactionElement border bg-white">
                  <div class="transactionFees border-bottom mb-3">
                    <p class="mb-2 themecolor semibold">Transaction Fees</p>
                     <p class="f-14 themecolor" >0 (only network fees applies)</p>
                    <!-- <p class="f-14 themecolor" v-if="
                        getkeyType(selected_currency) == 'ERC20' &&
                        selected_currency != 'ETH'
                      ">
                      {{
                      withdraw_amount
                      ? numberFormat(21000 * withdraw_amount * 0.00000002)
                      : "0"
                      }}
                      ETH
                    </p>
                    <p class="f-14 themecolor" v-else>
                      {{
                      withdraw_amount
                      ? numberFormat((withdraw_amount / 100) * 0.5)
                      : "0"
                      }}
                      {{ selected_currency }}
                    </p> -->
                  </div>
                  <div class="transactionFees border-bottom mb-3">
                    <p class="mb-2 themecolor semibold">Total Withdrawal</p>
                    <p class="f-14 themecolor">
                      {{
                      withdraw_amount
                      ? withdraw_amount - (withdraw_amount / 100) * 0.5
                      : "0"
                      }}
                      {{ selected_currency }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-12 text-center mt-4 mt-md-5">
              <a href="javascript:void(0)" class="cap_btn secondaryBG lg min-250" data-toggle="modal"
                data-target="#exampleModalCenter" @click="checkWithdraw()">Review Withdrawal</a>
            </div>
          </div>


          

          <!-- <crypto-withdrawal-section v-if="taskTab == 'cryptoWithdrawal'" /> -->
          <fiat-withdrawal-section v-if="taskTab == 'fiatWithdrawal'" />

          <div class="col-12">
            <div class="recentTransactions mt-3 mt-md-5 pt-4">
              <div class="headerElement my-4 d-flex align-items-center justify-content-between">
                <h3 class="mb-0">Withdrawal History</h3>
                <div class="d-flex align-items-center flex-wrap tpBt">
                  <div class="d-flex border align-items-center px-2 py-2 mx-2 border-radius-10">
                    <!-- <div class="form-group mb-0">
                      <select name="Date" class="form-control" v-model="dateType"  @change="changeFilter()">
                        <option value="">Select Days</option>
                        <option value="7 Days">Last 7 Days</option>
                        <option value="15 Days">Last 15 Days</option>
                        <option value="30 Days">Last 30 Days</option>
                        <option value="3 Months">Last 3 Months</option>
                        <option value="6 Months">Last 6 Months</option>
                      </select>
                    </div> -->
                    <a  href="javascript:void(0)"  @click="showDownloadHistoryPopup = true" class="borderBtn ml-2 mb-0" >Download History</a>
                  </div>
                </div>
              </div>
              <div class="border position-relative border-radius-15">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Date/ Time</th>
                        <th>Asset</th>
                        <th >Method</th>
                        <th>Amount Requested</th>
                        <th>Fees</th>
                        <th>Net Withdrawn Amount</th>
                        <th>Address</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody v-if="
                        'totalRecords' in withdrawalList &&
                        withdrawalList.totalRecords > 0 &&
                        !pageLoader
                      ">
                      <tr v-for="(val, index) in withdrawalList.records">
                        <td>{{ formatDate(val.created) }}</td>
                        <td>
                          <p v-if="$env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</p>
                          <p v-else>{{ val.currency || "-" }}</p>
                        </td>
                        <td>
                          <span v-if="val.withdrawal_method != undefined && val.withdrawal_method != null && val.withdrawal_method != ''">{{ $env_var.withdrawal_type[parseInt(val.withdrawal_method)] }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>{{ val.amount || "-" }}</td>
                        <td><!-- 0.000010 -->-</td>
                        <td>{{ val.amount || "-" }}</td>
                        <td>
                        <span v-if="val.address != undefined && val.address != null && val.address != ''">{{val.address}}</span>
                        <span v-else>-</span>
                      </td>
                        <td class="alert" :class="getStatusClass(val.withdrawal_status)">
                          {{ getStatus(val.withdrawal_status) }}
                        </td>
                      </tr>
                    </tbody>
                    <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'6'"
                      :listLength="withdrawalList.totalRecords" v-else></table-loader>
                  </table>
                </div>
                <pagination :totalRecords="withdrawalList.totalRecords" :limit="pageLimit" :pageNo="page"
                  v-if="'totalRecords' in withdrawalList && withdrawalList.totalRecords > 0"></pagination>
              </div>
            </div>

            <!-- Review Withdrawal -->
            <div class="modal fade review show" style="display: block" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" v-if="showPopup">
              <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content" v-if="!success">
                  <div class="secondaryBG p-4 text-center">
                    <h4 class="mb-0 text-white">Withdrawal Confirmation</h4>
                  </div>
                  <div class="modal-body" v-if="transaction_id == ''">
                    <alert-notification v-if="notification_msg != ''" />
                    <loader v-if="pageLoader" />
                    <h5 class="text-center my-4 medium d-block">
                      {{ getCurrName(selected_currency) }} ({{ selected_currency }})
                    </h5>
                    <h6 class="my-4 medium d-block">Withdrawal Instructions</h6>
                    <p>
                      After clicking the withdrawal confirmation button, you will be
                      redirected to 2FA pannel for security code submission in context
                      to process your withdrawal
                    </p>
                    <ul class="s-convert border-top pt-3 mb-5">
                      <li class="d-flex align-items-center justify-content-between">
                        <p class="themecolor mb-0">Withdrawal Address</p>
                        <p class="themecolor mb-0">{{ crypto_addess }}</p>
                      </li>
                      <li class="d-flex align-items-center justify-content-between">
                        <p class="themecolor mb-0">Amount</p>
                        <p class="themecolor mb-0">
                          {{ withdraw_amount }} {{ selected_currency }}
                        </p>
                      </li>
                      <li class="d-flex align-items-center justify-content-between">
                        <p class="themecolor mb-0">Transaction Fees</p>
                        <p class="themecolor mb-0">
                         0 {{ selected_currency }}
                        </p>
                      </li>
                      <li class="d-flex align-items-center justify-content-between">
                        <p class="themecolor mb-0">
                          <strong>Withdrawal Net Total</strong>
                        </p>
                        <p class="themecolor mb-0">
                          <strong>{{withdraw_amount
                            ? withdraw_amount - 0
                            : "0"
                            }}
                            {{ selected_currency }}</strong>
                          <!-- <strong>{{
                            withdraw_amount
                            ? withdraw_amount - (withdraw_amount / 100) * 0.5
                            : "0"
                            }}
                            {{ selected_currency }}</strong> -->
                        </p>
                      </li>
                    </ul>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)" class="cap_btn large_btn border-btn" @click="showPopup = false">Cancel</a>
                      <a href="javascript:void(0)" class="cap_btn large_btn" @click="withdrawal_req_otp()">Confirm
                        Withdrawal</a>
                    </div>
                  </div>
                  <div class="modal-body" v-if="transaction_id != ''">
                    <alert-notification v-if="notification_msg != ''" />
                    <loader v-if="pageLoader" />
                    <h5 class="text-center my-4 medium d-block">
                      {{ getCurrName(selected_currency) }} ({{ selected_currency }})
                    </h5>
                    <h6 class="my-4 medium d-block">Withdrawal Instructions</h6>
                    <p>
                      After clicking the withdrawal confirmation button, you will be
                      redirected to 2FA pannel for security code submission in context
                      to process your withdrawal
                    </p>
                    <ul class="s-convert border-top pt-3 mb-5">
                      <input type="number" class="form-control" autocomplete="off" name="otp" maxlength="6"
                        placeholder="Enter otp" v-model="otp" v-validate="'required|min:6'" />
                      <span v-if="submitted && errors.has('otp')" class="text-danger">{{ errors.first("otp") }}</span>
                    </ul>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)" class="cap_btn large_btn border-btn" @click="
                          showPopup = false;
                          transaction_id = '';
                        ">close</a>
                      <a href="javascript:void(0)" class="cap_btn large_btn" @click="withdrawal_req_otp_check()">Confirm
                        Withdrawal</a>
                    </div>
                  </div>
                </div>
                <div class="modal-content" v-else>
                  <div class="secondaryBG p-4 text-center">
                    <h4 class="mb-0 text-white">withdrawal request has been submitted</h4>
                  </div>
                  <div class="modal-body">
                    <h5 class="text-center my-4 medium d-block">
                      {{ getCurrName(selected_currency) }} ({{ selected_currency }})
                    </h5>
                    <!-- <h6 class="my-4 medium d-block">Withdrawal Instructions</h6>
                                  <p>After clicking the withdrawal confirmation button, you will be redirected to 2FA pannel for security code submission in context to process your withdrawal</p> -->
                    <ul class="s-convert border-top pt-3 mb-5"></ul>
                    <div class="d-flex align-items-center justify-content-between">
                      <a href="javascript:void(0)" class="cap_btn large_btn border-btn" @click="
                          showPopup = false;
                          success = false;
                        ">Close</a>
                      <!-- <a href="javascript:void(0)" class="cap_btn large_btn" @click="withdrawal_req_otp()">Confirm Withdrawal</a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="modal fade review show" style="display: block" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" v-if="showDownloadHistoryPopup">
              <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content" >
                  <div class="p-4 border-bottom modal-header bg-none">
                    <h4 class="mb-0">Withdrawal History</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showDownloadHistoryPopup = false; dateType = ''">
                        <span aria-hidden="true" >&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" >
                    <!-- <alert-notification v-if="notification_msg != ''" /> -->
                    <!-- <loader v-if="pageLoader" /> -->
                    <div class="form-group mb-3">
                      <select name="Date" class="form-control" v-model="dateType">
                        <option value="">Select Days</option>
                        <option value="7 Days">Last 7 Days</option>
                        <option value="15 Days">Last 15 Days</option>
                        <option value="30 Days">Last 30 Days</option>
                        <option value="3 Months">Last 3 Months</option>
                        <option value="6 Months">Last 6 Months</option>
                      </select>
                    </div>
                    <div class="form-group mb-0 d-flex align-items-center">
                      <a href="javascript:void(0)" class="cap_btn large_btn" @click="changeFilter()">Submit</a>
                      <a href="javascript:void(0)" class="cap_btn large_btn border-btn ml-3" @click="showDownloadHistoryPopup = false; dateType = ''">Cancel</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
  import tradingMixins from "@/plugins/trading";
  import { Const } from "@/plugins/vue-provider-cache/const.mod";
  import math from "../../../../static/website/js/math.js";
  import fiatWithdrawalSection from "./withdrawal-fiat"
  import moment from "moment";
  import cryptoWithdrawalSection from "./withdrawal-crypto"
  export default {
    name: "deposit-section",
    mixins: [depositWithdrawalMixins, tradingMixins],
    data() {
      return {
        taskTab: "cryptoWithdrawal",
        dateType: "",
        downloadData : {},
        showDownloadHistoryPopup : false,



        pageLoader: false,
        notification_msg: "",
        notification_type: "",
        errImage: [],
        submitted: false,
        isCrypto: true,
        allowfiat: true,
        step: "1",
        notCryptoCurrency: ['EURO', 'USD', 'AUD', 'GBP', 'JPY','EUR'],
        margin_list: {},
        showCurr: false,
        selected_currency: "BTC",
        searchCurr: "",

        withdraw_amount: "",
        crypto_addess: "",

        crypto: false,

        page: "1",
        pageLimit: "10",

        transaction_id: "",
        otp: "",
        success: false,
        showPopup: false,
      };
    },
    components: {
      fiatWithdrawalSection, cryptoWithdrawalSection
    },
    computed: {
      currentBal() {
        try {
          let sendCurr = this.selected_currency,  outerCount = 0, returnData = 0  ;
          for(let key in this.margin_list){
            outerCount++
            let  count = 0 ;
            for(let inerkey in this.$env_var.restricted_currencies){
              count++
              if(this.$env_var.restricted_currencies[inerkey].currency_name == this.selected_currency){
                sendCurr = this.$env_var.restricted_currencies[inerkey].orginal_name
              }

              if(count == Object.keys(this.$env_var.restricted_currencies).length){
                if(sendCurr == this.margin_list[key].currency && parseFloat(this.margin_list[key].amount) > 0 ){
                  returnData = this.margin_list[key].amount ;
                }
              }
              
            }
            
            if(outerCount == Object.keys(this.margin_list).length){
              console.log('returnData==> ',returnData)
              return returnData;
            }
          }
          // return Object.values(this.margin_list).filter(
          //   (val) =>
          //     this.selected_currency == val.currency && parseFloat(val.amount) > 0
          // )[0].amount;
        } catch (e) {
          return 0;
        }
      },
    },
    watch: {
      tradingAccount(value) {
        this.getCurrency(value);
        this.listing(value);
      },
    },
    methods: {
      currencyListNameClassFunc(value){
        if(this.$env_var.restricted_currencies.hasOwnProperty(value.symbol) && this.$env_var.restricted_currencies[value.symbol].currency_name == this.selected_currency){
          return 'active' ;
        }else if(value.symbol == this.selected_currency){
          return 'active' ;
        }else{
          return '';
        }
      },
      currencyListNameFunc(value){
        this.selected_currency = value.symbol
        if(this.$env_var.restricted_currencies.hasOwnProperty(value.symbol)){
          this.selected_currency = this.$env_var.restricted_currencies[value.symbol].currency_name
        }
        
        this.searchCurr = ''
      },
      changeFilter() {
        if(this.dateType != ''){
          this.withdrawalListing(this.tradingAccount);
        }else{
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Please select field',
            duration: 1000
          });
        }
        
      },
      // getBankDetails() {alert()
      //       let json = {
      //           globalParams: {},
      //           localParams: { parameter: this },
      //       }
      //       this._runGetBankDetails(json);
      //   },
      withdrawal_req_otp_check() {
        if (this.pageLoader) {
          return;
        }
        const _that = this;
        _that.submitted = true;
        _that.$validator.validate().then((valid) => {
          if (valid) {
            this._runWithdrawalCheckOtp({
              globalParams: {
                trans_id: _that.transaction_id,
                otp: _that.otp,
                verify: "",
              },
              localParams: { parameter: this },
            });
          }
        });
      },
      checkWithdraw() {
        var account_id = "";
        this.tradingAccount[0].subAccounts.forEach((value) => {
          if(this.$env_var.restricted_currencies.hasOwnProperty(value.currency) && this.$env_var.restricted_currencies[value.currency].currency_name == this.selected_currency){
            account_id = value.act_account_id;
          }else if(this.selected_currency == value.currency) {
            account_id = value.act_account_id;
          }
        });
        if (account_id == "") {
          this.notification_msg = "error";
          this.notification_type =
            this.selected_currency +
            " currency has no available balance to withdraw.";
          setTimeout(() => {
            this.notification_msg = "";
            this.notification_type = "";
          }, 5000);
          return;
        } else {
          const _that = this;
          _that.submitted = true;
          _that.$validator.validate().then((valid) => {
            if (valid) {
              _that.showPopup = true;
            }
          });
        }
      },
      withdrawal_req_otp() {
        if (this.pageLoader) {
          return;
        }
        var account_id = "";
        this.tradingAccount[0].subAccounts.forEach((value) => {
          if(this.$env_var.restricted_currencies.hasOwnProperty(value.currency) && this.$env_var.restricted_currencies[value.currency].currency_name == this.selected_currency){
            account_id = value.act_account_id;
          }else if(this.selected_currency == value.currency) {
            account_id = value.act_account_id;
          }
        });
        if (account_id == "") {
          this.notification_msg = "error";
          this.notification_type =
            this.selected_currency +
            " currency has no available balance to withdraw.";
        }
        // console.log('withdrawalItem',this.selected_currency,this.tradingAccount[0].subAccounts)
        const _that = this;
        _that.submitted = true;
        _that.$validator.validate().then((valid) => {
          if (valid) {
            var sendCurr = _that.selected_currency ;
            for(let key in _that.$env_var.restricted_currencies){
              if(_that.$env_var.restricted_currencies[key].currency_name == _that.selected_currency){
                sendCurr = _that.$env_var.restricted_currencies[key].orginal_name
              }
            }
            var inputJson = {
              globalParams: {
                account_id: _that.tradingAccount[0].account_id,
                act_account_id: account_id,
                amount: _that.withdraw_amount,
                address: _that.crypto_addess,
                crypto: sendCurr,
                method_id: "",
                withdrawal_method: "",
              },
              localParams: { parameter: _that },
            };
            if (!this.isCrypto) {
              inputJson.globalParams.method_id = this.withdrawal_Bank.split('-')[0]
              inputJson.globalParams.withdrawal_method = this.withdrawal_Bank.split('-')[1]
            }
            console.log("inputJson---->", inputJson);
            this._runWithdrawalRequestOtp(inputJson);
          }
        });
      },
      getStatusClass(val) {
        try {
          return this.depositStatus[val].class || "";
        } catch (e) {
          return "";
        }
      },
      getStatus(val) {
        try {
          return this.depositStatus[val].name || "-";
        } catch (e) {
          return "-";
        }
      },
      listing(accounts) {
        if(accounts == undefined || accounts == '' || accounts == null){
          accounts = this.tradingAccount
        }
        this.withdrawalListing(accounts);
      },
      withdrawalListing(accounts) {
        if (accounts && accounts.length) {
          let jsonData = {
            globalParams: {
              filter: {
                "withdrawal.account_id": this.tradingAccount.length
                  ? `${this.tradingAccount[0].account_id}`
                  : "0",
              },
              sort: [],
              search: ""
            },
            localParams: { parameter: this },
          };

          if(this.dateType != ''){
            if (this.dateType == "7 Days") {
              jsonData.globalParams.filter.from = moment().subtract(7, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "15 Days") {
              jsonData.globalParams.filter.from = moment().subtract(15, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "30 Days") {
              jsonData.globalParams.filter.from = moment().subtract(30, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "3 Months") {
              jsonData.globalParams.filter.from = moment().subtract(3, "months").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "6 Months") {
              jsonData.globalParams.filter.from = moment().subtract(6, "months").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            }
            jsonData.localParams.pageFlag = 'download'
          }else{
            jsonData.globalParams.page = this.page;
            jsonData.globalParams.perPage = parseInt(this.pageLimit);
          }
          this._runGetWithdrawalList(jsonData);
        }
      },
      formatfloat(num) {
        if (num) {
          num = parseFloat(num);
          try {
            return math.format(num, { notation: "fixed" }) || "";
          } catch (e) {
            try {
              return num.toFixed(8);
            } catch (e) {
              return "";
            }
          }
        } else {
          return 0;
        }
      },
      checkImage(val) {
        return this.errImage.includes(val.toLowerCase()) ? false : true;
      },
      handleImgErr(val) {
        var fullSrc = val.target.src.split(".");
        var src = fullSrc[fullSrc.length - 2].split("/");
        var img = src[src.length - 1];
        if (!this.errImage.includes(img)) {
          this.errImage.push(img);
        }
      },
      marginList() {
        let returnData = [],
          notZero = [];
        for (const key1 in this.withDepoCurList) {
          let data = this.withDepoCurList[key1];
          if (!(this.notCryptoCurrency.includes(data.symbol.toUpperCase()))){
            for (const key in this.margin_list) {
              if (
                this.margin_list[key].currency == data.symbol &&
                parseFloat(this.margin_list[key].amount) > 0
              ) {
                data["amount"] = this.margin_list[key].amount;
              }
            }
            if (data["amount"] > 0) {
              notZero.push(data);
            } /*else{
                      returnData.push(data);
                  }*/
          }
        }
        var search = this.searchCurr.toLowerCase();
        return notZero
          .concat(returnData)
          .filter((val) =>
            this.searchCurr
              ? val.symbol.toLowerCase().includes(search) ||
              val.currency_name.toLowerCase().includes(search)
              : true
          );
      },
      subscribPairs(pairList) {
        try {
          if (pairList.length > 0) {
            this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
              "S_PF_PF"
            ].subscribe(pairList);
          }
        } catch (e) {
          setInterval(() => {
            this.subscribPairs(pairList);
          }, 1000);
        }
      },
      getCurrency(value) {
        if (value.length > 0 && value[0].subAccounts.length > 0) {
          let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
          let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
          this.subscribPairs(btcPair.concat(usdPair));
          this._runGetMarginInfo({
            globalParams: { account_id: this.tradingAccount[0].account_id },
            localParams: { parameter: this, page: "withdrawal" },
          });
        }
      },
      downloadTransactions() {
        if(this.downloadData.records && this.downloadData.records.length > 0){
          let headerCols = [],
          data = [],
          filename = "";
          filename = "withdrawals";
          headerCols = Object.keys(this.downloadData.records[0]);
          data = this.downloadData.records;
          this.csvExport(data, headerCols, filename);
        }else{
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'No data available',
            duration: 1000
          });
        }
      },
      csvExport(data, headers, filename) {
        let csvData = headers.join(", ").replace(/_/g, " ").toUpperCase();
        csvData += "\n";
        data.map((row) => {
          headers.map((i, index) => {
            if (index < headers.length - 1) {
              csvData += `${row[i]}, `;
            } else {
              csvData += `${row[i]}\n`;
            }
          });
        });
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvData);
        hiddenElement.target = "_blank";
        hiddenElement.download = filename;
        hiddenElement.click();
      },
    },
    created() {
      if (this.$route.query.withdraw) {
        this.selected_currency = this.$route.query.withdraw;
        if(this.$env_var.restricted_currencies.hasOwnProperty(this.$route.query.withdraw) ){
          this.selected_currency = this.$env_var.restricted_currencies[this.$route.query.withdraw].currency_name;
        }
      }
      this.getCurrency(this.tradingAccount);
      this.withdrawalListing(this.tradingAccount);
      this._runGetWithDepoCurList({
        globalParams: {},
        localParams: { parameter: this, 'link': true },
      });

      // this._runGetWithdrawalMethods({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
      let selected_currency = this.selected_currency.toUpperCase()
      for(let key in this.$env_var.restricted_currencies){
        if(this.$env_var.restricted_currencies[key].currency_name == this.selected_currency){
          selected_currency = this.$env_var.restricted_currencies[key].orginal_name
        }
      }
      if (this.notCryptoCurrency.includes(selected_currency)) {
        this.isCrypto = false
        // console.log(Object.values(this.$env_var.fiatAllowCountries))
        if (this.get_user.profile.country && Object.values(this.$env_var.fiatAllowCountries).includes(this.get_user.profile.country)) {
          this.allowfiat = true
        }
      }
    },
    updated() {
      if (this.showCurr) {
        document.getElementById("searchCurr").focus();
      }
    },
    mounted() {
      const _that = this;
      $(document).on("click", function (event) {
        if (!$(event.target).closest(".showCurr").length) {
          _that.showCurr = false;
        }
      });
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/withdrawal.vue